export default "__VITE_ASSET__be59b96d__"